<template>
  <div id="principal">
    <v-flex xs12 text-xs-center class="pt-4">
      <h1 class="grand">HiroPay Qui sommes - nous?</h1>
    </v-flex>
    <v-layout row wrap class="container" justify-space-between>
      <v-flex md5 hidden-sm-and-down>
        <img src="/img/invest.svg" text-xs-center width="400" height="500" alt="bitcoin" />
      </v-flex>
      <v-flex xs12 class="btc" text-xs-center hidden-md-and-up>
        <img src="/img/invest.svg" width="200" height="200" alt="bitcoin" />
      </v-flex>
      <v-flex md6>
        <v-card class="mr-5 my-5">
          <v-divider></v-divider>
          <v-divider></v-divider>
          <v-divider></v-divider>
        </v-card>
        <v-card-text>
          <h2>
            HIROPAY est la plateforme par excellence de change de devise à partir du Franc Cfa XOF.
            Hiropay a été mis en place pour répondre à la problématique concernant le change de devise dans les pays utilisant le Franc Cfa XOF.
            <br />
            <br />
          </h2>
        </v-card-text>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-layout row wrap class="container" justify-space-between>
      <v-flex md6>
        <v-card class="mr-5 my-5"></v-card>
        <v-card-text>
          <v-flex xs12 class="btc" text-xs-center hidden-md-and-up>
            <img src="/img/pay.svg" width="175" height="175" alt="bitcoin" />
          </v-flex>
          <h2>Notre expérience dans le domaine financier en général et du change en particulier nous a permis de mettre en place cette plateforme qui se positionne comme étant un soulagement absolu vis-à-vis de l'échange des monnaies digitales qui sont de nos jours l'une des principales portes d'entrée dans l'économie mondiale.</h2>
          <br />
          <br />
        </v-card-text>
      </v-flex>
      <v-flex md5 hidden-sm-and-down>
        <img src="/img/pay.svg" text-xs-center width="500" height="500" alt="bitcoin" />
      </v-flex>
    </v-layout>

    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-layout row wrap class="container" justify-space-between>
      <v-flex md6>
        <v-card class="mr-5 my-5"></v-card>
        <v-card-text>
          <br />
          <br />
        </v-card-text>
      </v-flex>
      <v-flex md5>
        <h2>
          implantée au togo HiroPay se veut une plateforme de change de devise, nous mettons en contact les acheteurs et les vendeurs facilitant
          ainsi l'échange dans les pays utilisant le Franc CFa
        </h2>
      </v-flex>
    </v-layout>

    <div class="container mb-5">
      <v-flex xs12 text-xs-center class=" my-5">
        <h1>NOUS CONTACTER</h1>
      </v-flex>
      <v-layout row wrap justify-space-around>
        <v-flex xs4>
          <a href="https://t.me/joinchat/G55SVhXVdlNqD_TPgBB4QQ" target="_blank">
            <button class=" telegram">
            <i class="fab fa-telegram fa-2x">telegram</i>
          </button>
          </a>
        </v-flex>
        <v-flex xs4>
          <a href="https://wa.me/22892259267" target="_blank">
           <button class=" whatsapp">
            <i class="fab fa-whatsapp fa-2x">whatsapp</i>
          </button>
          </a>
        </v-flex>
        
      </v-layout>
    </div>

    <subFooter />
  </div>
</template>

<script>
const subFooter = () => import("../components/subFooter");
export default {
  components: {
    subFooter
  },
  mounted() {
    (function(b, i, t, C, O, I, N) {
      window.addEventListener(
        "load",
        function() {
          if (b.getElementById(C)) return;
          (I = b.createElement(i)), (N = b.getElementsByTagName(i)[0]);
          I.src = t;
          I.id = C;
          N.parentNode.insertBefore(I, N);
        },
        false
      );
    })(document, "script", "https://widgets.bitcoin.com/widget.js", "btcwdgt");
  },
  metaInfo() {
    return {
      title: 'HIROPAY -   acheter et vendre les  cryptomonnaies en afrique  Change de devise ',
      meta: [
        {
          name: 'description',
          content: `HIROPAY est la plateforme par excellence de change de devise et de cryptomonnaies à partir du Franc CFA XOF. Implantée au Togo, elle facilite les échanges pour les utilisateurs au Bénin, Burkina Faso, Côte d’Ivoire, Guinée-Bissau, Mali, Niger, Sénégal et Togo. Nous connectons acheteurs et vendeurs pour échanger devises traditionnelles et monnaies digitales comme le Bitcoin.`,
        },
        {
          name: 'keywords',
          content: 'HIROPAY, change de devise, cryptomonnaies, Franc CFA XOF, Bitcoin,vente, acheter, vendre,   échange monnaie digitale, Togo, Bénin, Burkina Faso, Côte d’Ivoire, Guinée-Bissau, Mali, Niger, Sénégal, économie mondiale',
        },
        {
          name: 'author',
          content: 'HIROPAY',
        },
        {
          property: 'og:title',
          content: 'HIROPAY - Change de devise et cryptomonnaies en Franc CFA XOF',
        },
        {
          property: 'og:description',
          content: `HIROPAY facilite l'échange de devises et de cryptomonnaies comme le Bitcoin dans la zone CFA XOF, couvrant le Bénin, Burkina Faso, Côte d’Ivoire, Guinée-Bissau, Mali, Niger, Sénégal et Togo.`,
        },
        {
          property: 'og:image',
          content: 'https://hiropay.com/img/moov.png', // Remplacez par l'URL réelle de l'image
        },
        {
          property: 'og:url',
          content: 'https://hiropay.com', // Remplacez par votre URL
        },
      ],
    };
  },
};
</script>

<style scoped>
#principal {
  background: #f2f2f2;
  height: 100%;
}
h2 {
  font-family: inherit;
  font-weight: bold;
  font-style: inherit;
  vertical-align: baseline;
}
h1.grand {
  font-family: 'Teko' !important;
  font-weight: bold !important;
  font-size: 3em !important;
  letter-spacing: 2px !important;
  line-height: 1.5;
  margin-bottom: 10px;
}
button{
 
  border: none;
  color: white;
  padding: 10px 15px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}
button.telegram{
background-color: #0088cc; /* Green */
}
button.whatsapp{
background-color: #25d366; /* Green */
}
button.facebook{
background-color: #3b5998; /* Green */
}

</style>
